import { PageEvent } from "@angular/material/paginator";
import { PaginationParameters } from "../../core/models/pagination-paramters";
import { MonthlyTrueUpCalculationFilterRepresentation } from "./monthly-true-up-calculation-filter-representation-base";

export class MonthlyTrueUpCalculationFilterProperties
{
  paginationParameters: PaginationParameters;
  filterRepresentation:MonthlyTrueUpCalculationFilterRepresentation
}